import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Select, Divider, Button } from 'antd';
import qs from 'qs';
import { cleanObject } from '@/utils/helpers';

const { Option } = Select;

const parseValue = (val) => {
    if (!val || typeof val !== 'string') return [];

    return val.split(',').map(item => {
        return /^0\d+$/.test(item) ? item : isNaN(item) ? item : Number(item);
    });
};


class FilterableMultiSelect extends Component {
    state = {
        selectedValues: []
    };

    componentDidMount() {
        const query = qs.parse(this.props.location.search.slice(1));
        const queryValue = query[this.props.parameterName];

        this.setState({ selectedValues: queryValue ? parseValue(queryValue) : [] });
    }

    handleSelectAll = () => {
        const { options, parameterName, optionValue } = this.props;
        const allValues = options.map(item => item[optionValue]);
        this.handleOnChange(parameterName, allValues);
        this.setState({ selectedValues: allValues });
    }

    handleDeselect = (deselectedValue) => {
        const updatedValues = this.state.selectedValues.filter(value => value !== deselectedValue);
        this.setState({ selectedValues: updatedValues });
        this.handleOnChange(this.props.parameterName, updatedValues);
    }

    handleOnChange = (name, value) => {
        // NORMALIZE: luôn convert về array
        const values = Array.isArray(value)
            ? value
            : value !== undefined && value !== null
                ? [value]
                : [];

        let queryValue = qs.parse(this.props.location.search.slice(1));

        if (name === this.props.parameterName) {
            if (values.length > 0) {
                queryValue[name] = values.join(',');
            } else {
                delete queryValue[name];
            }
        } else {
            queryValue[name] = values;
        }

        queryValue = cleanObject(queryValue);

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(queryValue),
        });
    };


    handleOnClear = () => {
        const { parameterName } = this.props;
        this.setState({ selectedValues: [] }, () => {
            this.handleOnChange(parameterName, []);
        });
    }

    render() {
        const { options, placeholder, parameterName, optionValue, optionLabel, mode = 'multiple', singleMode } = this.props;
        const { selectedValues } = this.state;

        var query = qs.parse(this.props.location.search.slice(1));
        const queryValue = query[parameterName];

        const selectMode = singleMode ? undefined : mode

        return (
            <Select
                className="w-100"
                placeholder={placeholder}
                allowClear
                showArrow
                mode={selectMode}
                showSearch
                onClear={this.handleOnClear}
                value={selectedValues.length > 0 ? selectedValues : queryValue ? parseValue(queryValue) : []}
                onDeselect={this.handleDeselect}
                onChange={(value) => {
                    const values = Array.isArray(value)
                        ? value
                        : value !== undefined && value !== null
                            ? [value]
                            : [];

                    this.setState({ selectedValues: values }, () => {
                        if (values.length === 0) {
                            this.handleOnClear();
                        } else {
                            this.handleOnChange(parameterName, values);
                        }
                    });
                }}

                defaultValue={queryValue ? parseValue(queryValue) : []}
                filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                dropdownRender={menu => (
                    <>
                        {menu}
                        <Divider style={{ margin: '8px 0' }} />
                        <div style={{ padding: '2px 8px 8px 8px' }}>
                            <Button className='w-100' type="dashed" onClick={this.handleSelectAll}>
                                Chọn tất cả
                            </Button>
                        </div>
                    </>
                )}
            >
                {options.map((item, index) => (
                    <Option key={`${item[optionValue]}_${index}`} value={item[optionValue]}>
                        {item[optionLabel]}
                    </Option>
                ))}
            </Select>
        );
    }
}

export default withRouter(FilterableMultiSelect);
